export function initialiseNavigation() {
	document.querySelectorAll<HTMLElement>('[data-navigation-dropdown]').forEach(root => {
		const trigger = root.querySelector<HTMLButtonElement>(':scope > button');
		const menu = root.querySelector<HTMLElement>(':scope > .header-links-menu');
		if (!trigger || !menu) return;
		let mouseHovering = false;
		let mouseFocusedTrigger = false;
		const setOpen = (open: boolean) => {
			trigger.setAttribute('aria-expanded', String(open));
			menu.hidden = !open;
		};
		trigger.addEventListener('pointerdown', event => {
			mouseFocusedTrigger = event.pointerType === 'mouse';
		});
		trigger.addEventListener('click', event => setOpen(mouseHovering && event.detail > 0 ? true : menu.hidden));
		root.addEventListener('keydown', event => {
			mouseFocusedTrigger = false;
			if (event.key === 'Escape') {
				setOpen(false);
				trigger.focus();
			} else if (event.key === 'ArrowDown' && event.target === trigger) {
				event.preventDefault();
				setOpen(true);
				menu.querySelector<HTMLAnchorElement>('a')?.focus();
			}
		});
		root.addEventListener('focusout', event => {
			if (!(event.relatedTarget instanceof Node) || !root.contains(event.relatedTarget)) {
				mouseFocusedTrigger = false;
				if (!mouseHovering) setOpen(false);
			}
		});
		document.addEventListener('click', event => {
			if (event.target instanceof Node && !root.contains(event.target)) setOpen(false);
		});
		if (root.dataset.navigationDropdown === 'hover') {
			root.addEventListener('pointerenter', event => {
				if (event.pointerType === 'mouse') {
					mouseHovering = true;
					setOpen(true);
				}
			});
			root.addEventListener('pointerleave', event => {
				if (event.pointerType !== 'mouse') return;
				mouseHovering = false;
				const keyboardFocusedTrigger = document.activeElement === trigger && !mouseFocusedTrigger;
				if (!menu.contains(document.activeElement) && !keyboardFocusedTrigger) setOpen(false);
			});
		}
	});
}
